import { render, staticRenderFns } from "./ViewCandidatesBody.vue?vue&type=template&id=dea76470&scoped=true&"
import script from "./ViewCandidatesBody.vue?vue&type=script&lang=ts&"
export * from "./ViewCandidatesBody.vue?vue&type=script&lang=ts&"
import style0 from "./ViewCandidatesBody.vue?vue&type=style&index=0&id=dea76470&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dea76470",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCol,VRow,VSkeletonLoader})
